
import Vue from 'vue';
import SkeletonLoader from '@/components/SkeletonLoader.vue';

export default Vue.extend({
  name: 'Progress',
  components: { SkeletonLoader },

  props: {
    promise: { required: true, validator: (o: any) => typeof o.then === 'function' },
    retainState: { type: Boolean, default: false },
    noSpinner: { type: Boolean as () => boolean, required: false },
    skeleton: { type: Boolean as () => boolean, default: false },
  },

  data() {
    return {
      pending: true,
      success: false,
      failure: false,
      result: null as any,
      error: null as any,
    };
  },

  methods: {
    resolve(result?: any) {
      this.result = result;
      this.pending = false;
      this.success = true;
      this.$emit('change', 'success');
      this.$emit('success', result);
    },
    reject(error: Error) {
      this.error = error || new Error('undefined');
      this.pending = false;
      this.failure = true;
      this.$emit('change', 'failure');
      this.$emit('failure', this.error);
    },
    reset() {
      this.pending = true;
      this.success = false;
      this.failure = false;
    },
  },

  watch: {
    promise: {
      immediate: true,
      handler() {
        if (!this.retainState) {
          this.reset();
        }
        this.$emit('change', 'pending');
        (this.promise as any)
          .then(this.resolve)
          .catch(this.reject);
      },
    },
  },
});
